import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll('.bpa-slider');

  sliders.forEach((sliderEl) => {
    // Default breakpoints
    let breakpoints = {
      768: { perPage: 2 },
      992: { perPage: 3 },
      1440: { perPage: 4 },
      1920: { perPage: 5 },
    };

    // If the slider contains `.cards`
    if (sliderEl.classList.contains('cards')) {
      breakpoints = {
        768: { perPage: 2 },
        992: { perPage: 2 },
        1440: { perPage: 3 },
      };
    }

    // Store Splide instance in a variable
    const slider = new Splide(sliderEl, {
      type: "slide",
      rewind: true,
      rewindSpeed: 800,
      perPage: 1,
      perMove: 1,
      focus: 0,
      arrows: false,
      pagination: false,
      gap: '2.4rem',
      mediaQuery: "min",
      breakpoints: breakpoints,
    });

    slider.mount();

    // Find the matching arrows container by data-slider-id
    const sliderId = sliderEl.id;
    const arrowsContainer = document.querySelector(`.slider-block__arrows[data-slider-id="${sliderId}"]`);

    if (!arrowsContainer) return;

    const prevBtn = arrowsContainer.querySelector('.slider-arrow__prev');
    const nextBtn = arrowsContainer.querySelector('.slider-arrow__next');

            // Function to toggle arrows visibility
            const toggleArrows = () => {
              const totalSlides = slider.length;
              const perPage = slider.options.perPage;
        
              // Hide arrows if slides <= perPage
              if (totalSlides <= perPage) {
                arrowsContainer.style.display = "none";
              } else {
                arrowsContainer.style.display = "";
              }
            };
        
            // Run once after mount
            toggleArrows();
        
            // Also re-check on resize since perPage changes with breakpoints
            slider.on("resize", () => {
              toggleArrows();
            });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (slider.index === 0) {
          slider.go(slider.length - 1);
        } else {
          slider.go('-1');
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const lastSlideIndex = slider.length - slider.options.perPage;

        if (slider.index >= lastSlideIndex) {
          slider.go(0);
        } else {
          slider.go('+1');
        }
      });
    }
  });
});
